// src/api/optionsApi.ts

import { getAuthToken } from "../security/AuthLogin";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

export interface Clasificacion {
  cod_clasificacion: string;
  clasificacion: string;
}

export interface CodCpv {
  cod_cpv: string;
  cpv: string;
  cod_clasificacion: string; // ← NUEVO CAMPO
}

export const fetchClasificaciones = async (): Promise<Clasificacion[]> => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/clasificaciones`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Error al obtener clasificaciones");
  return response.json();
};

export const fetchCodCpv = async (search?: string): Promise<CodCpv[]> => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (search) params.append("search", search);

  const response = await fetch(`${API_URL}/cod_cpv?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Error al obtener CPV");
  return response.json();
};
